import CourseSessions from './CourseSessionsContainer';

export default CourseSessions;
